var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#CFCFCF;}\n\t.st2{fill:none;stroke:#BABABA;stroke-width:2.4482;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.4482;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#D2D2D2;}\n\t.st5{fill:#BABABA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.8,91.4c-20.5,0-41.3-0.8-60.9-6.3c-19.1-5.3-36.7-15.6-52.4-27.5c-10.3-7.8-19.6-13.9-32.9-13 c-13,0.7-25.5,5.6-35.5,14c-16.9,14.7-14.4,42.2-7.6,61.5c10.2,29.1,41.2,49.2,67.5,62.4c30.4,15.2,63.9,24,97.4,29.1 c29.4,4.5,67.1,7.7,92.6-11.5c23.4-17.6,29.8-57.9,24.1-85.1c-1.4-8-5.7-15.3-12-20.4c-16.4-12-40.9-4-59.4-3.6 C227.8,91.2,220.8,91.4,213.8,91.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.7,259.2c49.6,0,89.9-2.5,89.9-5.6c0-3.1-40.2-5.6-89.9-5.6s-89.9,2.5-89.9,5.6 C73.8,256.7,114,259.2,163.7,259.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.8,179.6c1.3,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4S33.5,179.6,34.8,179.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.2,210v10.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.9,215.3h10.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M264.6,44H62.7c-5.2,0-9.5,4.2-9.5,9.4V192c0,5.2,4.2,9.4,9.5,9.4h201.9c5.2,0,9.5-4.2,9.5-9.4V53.5 C274,48.3,269.8,44,264.6,44z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.3,85.9H83c-3.7,0-6.8,3-6.8,6.8v88c0,3.7,3,6.8,6.8,6.8h161.3c3.7,0,6.8-3,6.8-6.8v-88 C251,88.9,248,85.9,244.3,85.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274,70.6V53.6c0-1.2-0.2-2.5-0.7-3.6c-0.5-1.2-1.2-2.2-2-3.1c-0.9-0.9-1.9-1.6-3.1-2.1 c-1.1-0.5-2.4-0.7-3.6-0.7H62.7c-1.2,0-2.5,0.2-3.6,0.7c-1.1,0.5-2.2,1.2-3.1,2.1c-0.9,0.9-1.6,1.9-2,3.1c-0.5,1.1-0.7,2.4-0.7,3.6 v17.1L274,70.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.6,28.2v30.5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.7,28.2v30.5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,30.2c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4 C238.1,29.1,239.1,30.2,240.5,30.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.5,32.3c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4C88.1,31.2,89.2,32.3,90.5,32.3 z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.9,14v10.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.7,19.3h10.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.6,4.5V15"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.3,9.8h10.6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133,159.3c1.6-7,5.4-13.2,11-17.6c5.6-4.5,12.5-6.9,19.6-6.9c7.1,0,14,2.4,19.6,6.9c5.6,4.5,9.4,10.7,11,17.6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.2,122.8c2.4,0,4.4-2,4.4-4.4c0-2.4-2-4.4-4.4-4.4c-2.4,0-4.4,2-4.4,4.4 C193.9,120.8,195.8,122.8,198.2,122.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M129.1,122.8c2.4,0,4.4-2,4.4-4.4c0-2.4-2-4.4-4.4-4.4c-2.4,0-4.4,2-4.4,4.4 C124.7,120.8,126.7,122.8,129.1,122.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEvent);
export default __webpack_public_path__ + "static/media/no-event.e6c12efaef061b8becf2775f132e6be8.svg";
export { ForwardRef as ReactComponent };